import Translations from "@translate/components/Chat/const";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

const agentKeyMap = {
  TECHNICAL_ANALYSIS_AGENT: "technical",
  FUNDAMENTAL_ANALYSIS_AGENT: "fundamental",
  MOMENTUM_ANALYSIS_AGENT: "momentum",
} as const;

type AgentVisualMeta = {
  iconName: any;
  loadingIcon: string;
  finishIcon: string;
  desc?: string;
  title?: string;
  name?: string;
};

export const streamReport = "report";
export const deepSearch = "deepsearch";

export const getAgentDataMap = (): Record<string, AgentVisualMeta> => {
  const agentDataMap: Record<string, AgentVisualMeta> = {
    [agentKeyMap.TECHNICAL_ANALYSIS_AGENT]: {
      desc: I18n.t(
        "Focuses purely on price data and metrics like RSI, MACD, and moving averages to show you the most probable price direction.",
      ),
      title: I18n.t("Technical Analaysis"),
      iconName: "movement-solid",
      loadingIcon: "/assets/images/chat/techAgent.webp",
      finishIcon: "/assets/images/techAgent.svg",
      name: I18n.t("Technical Analysis Agent"),
    },
    [agentKeyMap.FUNDAMENTAL_ANALYSIS_AGENT]: {
      desc: I18n.t(
        "Analyzes the project's strength, business performance, adoption, and key fundamentals to test long-term value, resilience, and potential.",
      ),
      title: I18n.t("Fundamental Analaysis"),
      iconName: "candlestick-solid",
      loadingIcon: "/assets/images/chat/fundAgent.webp",
      finishIcon: "/assets/images/fundAgent.svg",
      name: I18n.t("Fundamental Analysis Agent"),
    },
    [agentKeyMap.MOMENTUM_ANALYSIS_AGENT]: {
      desc: I18n.t(
        "Identifies and highlight what's hot as well as shifts in the market's mood and attention for a specific asset.",
      ),
      title: I18n.t("Momentum Analaysis"),
      iconName: "social-solid",
      loadingIcon: "/assets/images/chat/momentAgent.webp",
      finishIcon: "/assets/images/momentAgent.svg",
      name: I18n.t("Momentum Analysis Agent"),
    },
    edggy: {
      iconName: "",
      loadingIcon: "/assets/images/chat/agent_edggy.webp",
      finishIcon: "/assets/images/chat/agent_edggy.svg",
    },
    "360": {
      iconName: "aura",
      loadingIcon: "/assets/images/chat/agent_360.webp",
      finishIcon: "/assets/images/chat/agent_360.svg",
    },
    technicals: {
      iconName: "candlestick-solid",
      loadingIcon: "/assets/images/chat/fundAgent.webp",
      finishIcon: "/assets/images/fundAgent.svg",
    },
    macro: {
      iconName: "globe",
      loadingIcon: "/assets/images/chat/agent_macro.webp",
      finishIcon: "/assets/images/chat/agent_macro.svg",
    },
    "earning-call": {
      iconName: "Macro",
      loadingIcon: "/assets/images/chat/agent_earnings_call.webp",
      finishIcon: "/assets/images/chat/agent_earnings_call.svg",
    },
    fundamentals: {
      iconName: "movement-solid",
      loadingIcon: "/assets/images/chat/techAgent.webp",
      finishIcon: "/assets/images/techAgent.svg",
    },
    dividend: {
      iconName: "pie-chart-alt-2",
      loadingIcon: "/assets/images/chat/agent_dividend.webp",
      finishIcon: "/assets/images/chat/agent_dividend.svg",
    },
    sentiment: {
      iconName: "social-solid",
      loadingIcon: "/assets/images/chat/momentAgent.webp",
      finishIcon: "/assets/images/momentAgent.svg",
    },
    insider: {
      iconName: "search",
      loadingIcon: "/assets/images/chat/agent_insider.webp",
      finishIcon: "/assets/images/chat/agent_insider.svg",
    },
    sector: {
      iconName: "user",
      loadingIcon: "/assets/images/chat/agent_sector.webp",
      finishIcon: "/assets/images/chat/agent_sector.svg",
    },
    ipo: {
      iconName: "pio",
      loadingIcon: "/assets/images/chat/agent_ipo.webp",
      finishIcon: "/assets/images/chat/agent_ipo.svg",
    },
    derivatives: {
      iconName: "receipt",
      loadingIcon: "/assets/images/chat/agent_derivatives.webp",
      finishIcon: "/assets/images/chat/agent_derivatives.svg",
    },
    onchain: {
      iconName: "link",
      loadingIcon: "/assets/images/chat/agent_onchain.webp",
      finishIcon: "/assets/images/chat/agent_onchain.svg",
    },
    tokenomics: {
      iconName: "bitcoin-new",
      loadingIcon: "/assets/images/chat/agent_tokenomics.webp",
      finishIcon: "/assets/images/chat/agent_tokenomics.svg",
    },
    airdrop: {
      iconName: "airdrop",
      loadingIcon: "/assets/images/chat/agent_airdrop.webp",
      finishIcon: "/assets/images/chat/agent_airdrop.svg",
    },
    listing: {
      iconName: "current-location",
      loadingIcon: "/assets/images/chat/agent_listing.webp",
      finishIcon: "/assets/images/chat/agent_listing.svg",
    },
    // thinking独有
    nft: {
      iconName: "token2",
      loadingIcon: "/assets/images/chat/agent_nft.webp",
      finishIcon: "/assets/images/chat/agent_nft.svg",
      desc: I18n.t(
        "Understands rarity, communities, and culture. Knows which collections have real life and which are fading.",
      ),
      title: I18n.t("NFT"),
      name: I18n.t("NFT"),
    },
    launchpad: {
      iconName: "rocket",
      loadingIcon: "/assets/images/chat/agent_launchpad.webp",
      finishIcon: "/assets/images/chat/agent_launchpad.svg",
      desc: I18n.t(
        "Your early crypto signal finder. Watches presales, token launches, and first listings to reveal what’s worth exploring early.",
      ),
      title: I18n.t("Launchpad"),
      name: I18n.t("Launchpad"),
    },
    activity: {
      iconName: "line-chart",
      loadingIcon: "/assets/images/chat/agent_activity.webp",
      finishIcon: "/assets/images/chat/agent_activity.svg",
      desc: I18n.t(
        "Tracks the real activity of blockchains & DeFi: TVL, fees, volume, top protocols, and builder activity to find where real usage is rising.",
      ),
      title: I18n.t("Activity"),
      name: I18n.t("Activity"),
    },
  };
  return agentDataMap;
};

export const searchModeMap = {
  normal: 0,
  deepsearch: 1,
  agent: 2,
};
